import React, { useState } from "react";
import SiteWrapper from "../../../../SiteWrapper.react";
import DashboardAsignaciones from "./DashboardAsignaciones";


const MainAsignaciones = () => {

	return (
		<SiteWrapper>
				<div className="container otd-container">
					<DashboardAsignaciones
					/>
				  </div>
			
		</SiteWrapper>
	);
};

export default MainAsignaciones;







































































